var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.33337C13.1 6.33337 14 7.23337 14 8.33337C14 9.43337 13.1 10.3334 12 10.3334C10.9 10.3334 10 9.43337 10 8.33337C10 7.23337 10.9 6.33337 12 6.33337ZM12 16.3334C14.7 16.3334 17.8 17.6234 18 18.3334H6C6.23 17.6134 9.31 16.3334 12 16.3334ZM12 4.33337C9.79 4.33337 8 6.12337 8 8.33337C8 10.5434 9.79 12.3334 12 12.3334C14.21 12.3334 16 10.5434 16 8.33337C16 6.12337 14.21 4.33337 12 4.33337ZM12 14.3334C9.33 14.3334 4 15.6734 4 18.3334V20.3334H20V18.3334C20 15.6734 14.67 14.3334 12 14.3334Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePersonIcon);
export default __webpack_public_path__ + "static/media/white-person-icon.23f5931a98f927d782a6380a03f31898.svg";
export { ForwardRef as ReactComponent };